import { post } from "./utils";

export const setLocale = async (locale: string) => {
  await post(`locale/${locale}`, {});
};
